import {useState} from 'react'
import { useNavigate } from "react-router-dom"

export const useRequestPasswordReset = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const navigate = useNavigate()

    const requestPasswordReset = async (email) => {
        setIsLoading(true)
        setError(null)

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/send-reset-otp`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email}),
            credentials: 'include'
        })
        const json = await response.json()

        if (!response.ok) { //if response is error code, eg 400 then response.ok will be false
            setIsLoading(false)
            setError(json.error)
        }
        if (response.ok) {
            navigate('/reset-password', {state: {email}})
            setIsLoading(false)
        }
    }

    return ({requestPasswordReset, isLoading, error})
}